import { render, staticRenderFns } from "./VsLoading.vue?vue&type=template&id=9e397690&"
import script from "./VsLoading.vue?vue&type=script&lang=ts&"
export * from "./VsLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports